import { CohortEnumSchema } from '@eigtech/auth0-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { ChimeLifeCycleEventSchema } from './chime.js';
import { meetingServiceCorn } from './corn.js';
import { MeetingsMetadataSchema } from './meetingMetadata.js';
import { ParticipantSchema } from './participant.js';
export const MeetingStatusSchema = z.enum(['active', 'closed']);
export const MeetingStatus = MeetingStatusSchema.enum;
export const MeetingDetailsCornSchema = meetingServiceCorn('details');
export const MeetingDetailsSchema = z.object({
    appInstanceArn: z.string().optional(), // optional for hysterical raisins
    chimeChannelArn: z.string().optional(), // optional for hysterical raisins
    chimeEvents: z.array(ChimeLifeCycleEventSchema),
    chimeMeetingId: z.string().optional(),
    cohort: CohortEnumSchema,
    convertedFromCorn: CornSchema.optional(),
    description: z.string().optional(),
    endMeetingReason: z.string().optional(),
    endTime: z.string().datetime().optional(),
    entityId: CornSchema, // e.g. claim corn
    entityName: z.string().optional(),
    extractAudioJobId: z.string().optional(),
    fromUpload: z.boolean().optional(),
    id: MeetingDetailsCornSchema,
    meetingId: z.string(),
    metadata: MeetingsMetadataSchema,
    organizer: z.string(),
    participants: z.array(ParticipantSchema),
    startTime: z.string().datetime(),
    status: MeetingStatusSchema,
    transcriptionStarted: z.boolean().optional(), // optional for hysterical raisins
});
export const MeetingIdHaverSchema = MeetingDetailsSchema.pick({ meetingId: true });
export const ChimeMeetingIdHaverSchema = MeetingDetailsSchema.pick({
    chimeMeetingId: true,
}).required();
export const ExtractAudioJobIdHaverSchema = MeetingDetailsSchema.pick({
    extractAudioJobId: true,
}).required();
